import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	margin: 0 auto;
	color: ${CSSVars.black};
	padding: 50px 0;

	&.dark {
		h3 {
			color: ${CSSVars.white};
		}
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 0;
	}

	h3 {
		margin: 0 auto;
		font-size: ${CSSVars.fontSize2XL};
		font-weight: 300;
		max-width: fit-content;
		margin-bottom: 50px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize3XL};
		}
	}
`;
